var map = {
	"./aparat/colored-rounded.svg": "95bf",
	"./aparat/colored-square.svg": "233a",
	"./aparat/mono-rounded.svg": "d76a",
	"./aparat/mono-square.svg": "b804",
	"./facebook/colored-rounded.svg": "0ab3",
	"./facebook/colored-square.svg": "39c4",
	"./facebook/mono-rounded.svg": "fa61",
	"./facebook/mono-square.svg": "b01e",
	"./github/colored-rounded.svg": "df7a",
	"./github/colored-square.svg": "5c71",
	"./github/mono-rounded.svg": "05ff",
	"./github/mono-square.svg": "d37e",
	"./instagram/colored-rounded.svg": "8bb1",
	"./instagram/colored-square.svg": "ffa4",
	"./instagram/mono-rounded.svg": "79cb",
	"./instagram/mono-square.svg": "7738",
	"./linkedin/colored-rounded.svg": "c645",
	"./linkedin/colored-square.svg": "1afb",
	"./linkedin/mono-rounded.svg": "ffc9",
	"./linkedin/mono-square.svg": "c894",
	"./pinterest/colored-rounded.svg": "59cb",
	"./pinterest/colored-square.svg": "f14e",
	"./pinterest/mono-rounded.svg": "99d0",
	"./pinterest/mono-square.svg": "987b",
	"./telegram/colored-rounded.svg": "6d3c",
	"./telegram/colored-square.svg": "deca",
	"./telegram/mono-rounded.svg": "73ae",
	"./telegram/mono-square.svg": "4aa1",
	"./twitter/colored-rounded.svg": "0734",
	"./twitter/colored-square.svg": "6d3c2",
	"./twitter/mono-rounded.svg": "5121",
	"./twitter/mono-square.svg": "03ff",
	"./virgool/colored-rounded.svg": "78e9",
	"./virgool/colored-square.svg": "6bee",
	"./virgool/mono-rounded.svg": "cfb6",
	"./virgool/mono-square.svg": "279c",
	"./whatsapp/colored-rounded.svg": "3424",
	"./whatsapp/colored-square.svg": "bba7",
	"./whatsapp/mono-rounded.svg": "999d",
	"./whatsapp/mono-square.svg": "730b",
	"./youtube/colored-rounded.svg": "f67d",
	"./youtube/colored-square.svg": "73e1",
	"./youtube/mono-rounded.svg": "7492",
	"./youtube/mono-square.svg": "9087"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bec";